import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../ui/dialog';
import { Button } from '../../ui/button';

import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';
import { Label } from '../../ui/label';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { doSelectCompany } from '../../../modules/auth/stores/thunk';
import { Shuffle } from 'lucide-react';
import { Separator } from '../../ui/separator';

export const SelectCompanyModal = ({ user, collapsed }: { user: any; collapsed?: boolean }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [open, setOpen] = useState<boolean>(false);
  const [companyId, setCompanyId] = useState<string>(null);

  useEffect(() => {
    if (user.companies && !user.selectedCompany) {
      setOpen(true);
    }
    if (!user.selectedCompany) {
      setOpen(true);
    }
  }, [user]);

  const confirm = async () => {
    dispatch(doSelectCompany({ companyId }));

    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {user.selectedCompany && (
        <DialogTrigger className="cursor-pointer">
          {collapsed ? (
            <div className="flex items-center justify-center w-full py-4">
              <img
                src={user.selectedCompany.logoUrl}
                alt="logo"
                style={{
                  width: 30,
                  minWidth: 30,
                  maxWidth: 30,
                  cursor: 'pointer',
                }}
              />
            </div>
          ) : (
            <>
              <Separator />
              <div className="p-4 flex items-center justify-between">
                <div className="flex items-center">
                  <img
                    src={user.selectedCompany.logoUrl}
                    alt="logo"
                    style={{ width: 30, minWidth: 30, maxWidth: 30 }}
                  />
                  <div className="text-sm font-bold ml-2">{user.selectedCompany.name}</div>
                </div>
                <Shuffle size={16} className="mr-2" />
                {/* </SidebarTrigger> */}
              </div>
              <Separator />
            </>
          )}
        </DialogTrigger>
      )}
      <DialogContent hideClose>
        <DialogHeader>
          <DialogTitle>Select the company that you want to view</DialogTitle>
          <DialogDescription>You are connected to more than one company. Please select one.</DialogDescription>
        </DialogHeader>
        <RadioGroup
          className="mt-4"
          onValueChange={(v) => setCompanyId(v)}
          defaultValue={user.selectedCompany?.companyId}
        >
          {user.companies.map((c) => {
            return (
              <div key={c.companyId} className="flex items-center gap-3 mt-2 ">
                <RadioGroupItem value={c.companyId} id={c.companyId} />
                <Label htmlFor={c.companyId} className="cursor-pointer">
                  {c.name}
                </Label>
              </div>
            );
          })}
        </RadioGroup>
        <DialogFooter>
          <Button onClick={confirm}>Select company</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
